import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/shadcn/select";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/shadcn/tooltip";
import MaterialIcon from "@/components/general/common/MaterialIcon";
import type { Tournament } from "@/api/tournaments";

interface TeamsHeaderProps {
    selectedTournament?: string;
    onTournamentChange?: (name: string) => void;
    isLoading?: boolean;
    tournaments?: Tournament[];
}

export function TeamsHeader({
    selectedTournament,
    onTournamentChange,
    isLoading = false,
    tournaments,
}: TeamsHeaderProps) {
    return (
        <TooltipProvider>
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-6">
                <div>
                    <h1 className="text-4xl font-black text-primary tracking-tight mb-2 font-headline">Teams</h1>
                    <p className="text-on-surface-variant font-medium">League standings and team KPI overview.</p>
                </div>
                <div className="flex gap-3 items-center">
                    <div id="onboarding-teams-selector" className="w-full">
                        <Select
                            value={selectedTournament || ""}
                            onValueChange={(v) => onTournamentChange?.(v)}
                            disabled={isLoading || !tournaments || tournaments.length === 0}
                        >
                            <SelectTrigger className="w-full md:w-fit bg-surface-container-highest border-0">
                                <div className="flex items-center gap-2">
                                    <MaterialIcon name="sort" className="text-primary text-lg" />
                                    <SelectValue placeholder="Select tournament" />
                                </div>
                            </SelectTrigger>
                            <SelectContent>
                                {tournaments && tournaments.length > 0 ? (
                                    tournaments.map((tournament) =>
                                        tournament.matches.length === 0 ? (
                                            <Tooltip key={tournament.id} delayDuration={0}>
                                                <TooltipTrigger asChild>
                                                    <div
                                                        className="flex items-center px-2 py-1.5 text-sm opacity-50 cursor-not-allowed text-on-surface"
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        <span>{tournament.name}</span>
                                                    </div>
                                                </TooltipTrigger>
                                                <TooltipContent side="left">
                                                    <p>No data for this tournament</p>
                                                </TooltipContent>
                                            </Tooltip>
                                        ) : (
                                            <SelectItem key={tournament.id} value={tournament.name}>
                                                {tournament.name}
                                            </SelectItem>
                                        )
                                    )
                                ) : (
                                    <div className="px-3 py-2 text-on-surface-variant text-sm">
                                        No tournaments available
                                    </div>
                                )}
                            </SelectContent>
                        </Select>
                    </div>
                </div>
            </div>
        </TooltipProvider>
    );
}
